import React from "react";
import ContactComponent from "../components/Contact";
import NavBar from "../components/NavBar";

const Contact = () => {
  return (
    <>
      <NavBar id="contact" />
      <ContactComponent />
    </>
  );
};

export default Contact;
